module.exports = __webpack_public_path__ + "assets/img/172252b00065c57d4fbda6f989bbfb11.png";